import { render, staticRenderFns } from "./wl1Basic.vue?vue&type=template&id=7c780e88&"
import script from "./wl1Basic.vue?vue&type=script&lang=js&"
export * from "./wl1Basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports